import { render } from "./IconLocalCafe.vue?vue&type=template&id=876349d4"
import script from "./IconLocalCafe.vue?vue&type=script&lang=js"
export * from "./IconLocalCafe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__